import { type UseQueryResult, useQuery } from 'react-query';
import { BrokerSsoConfigurationKeyService } from '@wealthlane/api-services/wealthlane-identity-service';
import { PagedResultDto_BrokerSsoConfigurationKeyDto } from '@wealthlane/api-services/wealthlane-identity-service';

const useGetBrokerSsoKeyManagementList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  //   tableInfo: TableParamsType,
  id: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_BrokerSsoConfigurationKeyDto | undefined,
  unknown
> => {
  const brokerSsoKeyManagementList = useQuery(['getBrokerSsoKeyManagementList', id], async () => {
    if (id) {
      return await handleRequest(
        BrokerSsoConfigurationKeyService.getApiIdentityApiAppBrokerSsoConfigurationKeyByConfigurationId(
          id
        )
      );
    }
  });
  return brokerSsoKeyManagementList;
};

export default useGetBrokerSsoKeyManagementList;
